import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';

// Selectors
import { selectTimesheetEntriesApiErrorUuids } from 'services/timesheetTimesheetEntriesAPIErrors/selectors';
// @ts-ignore
import { selectErrorsTimesheetEntryUuids } from 'services/timesheetTimesheetEntriesForm/selectors';

export const selectIsError = createDeepEqualSelector(
    [selectTimesheetEntriesApiErrorUuids, selectErrorsTimesheetEntryUuids],
    (
        timesheetEntriesApiErrorUuidsState?: string[],
        errorsTimesheetEntryUuidsState?: string[]
    ): boolean =>
        !!(
            timesheetEntriesApiErrorUuidsState?.length ||
            errorsTimesheetEntryUuidsState?.length
        )
);
